import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountingService {
  constructor(private http: HttpClient) { }

  uploadMellatRecords(file: File, bank = 'mellat') {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<any[]>(environment.app.apiUrl + 'accounting/mellat-records/' + bank, formData).toPromise();
  }

  list(autoVerify: boolean, isRegistered: boolean, from = 0, limit = 50) {
    return this.http.post<{ records: any[], total: number }>(environment.app.apiUrl +
      `accounting/list/${autoVerify}`, { isRegistered, from, limit }).toPromise();
  }

  lock() {
    return this.http.put(environment.app.apiUrl + 'accounting/lock', {}).toPromise();
  }

  match(recordId: string, offset) {
    return this.http.post<{ payments: any[], matched: string[], balanced: boolean }>(environment.app.apiUrl + 'accounting/match/' + recordId + '/' + offset, {}).toPromise();
  }

  verify(record: any, combineWith?: string[]) {
    return this.http.post(environment.app.apiUrl + 'accounting/verify', { record, combineWith }).toPromise();
  }
  unverify(recordId: string, force = false) {
    return this.http.post(environment.app.apiUrl + 'accounting/unverify/' + recordId + (force ? '/true' : ''), {}).toPromise();
  }

  update(recordId: string) {
    return this.http.post(environment.app.apiUrl + `accounting/update/${recordId}`, {}).toPromise();
  }

  getBalance() {
    return this.http.get<any>(environment.app.apiUrl + 'accounting/balance', { params: { cb: Date.now() } }).toPromise();
  }
  beneficiaries() {
    return this.http.get<any[]>(environment.app.apiUrl + 'accounting/beneficiaries').toPromise();
  }
  accounts() {
    return this.http.get<any[]>(environment.app.apiUrl + 'accounting/accounts').toPromise();
  }
  contacts(data: any) {
    return this.http.post<any[]>(environment.app.apiUrl + 'accounting/contacts', data).toPromise();
  }
}
